export * from './upsertReminder.mutation-type'
export * from './upsertReminder.mutation'
export * from './upsertFine.mutation-type'
export * from './upsertFine.mutation'
export * from './upsertAnaliseChamados.mutation'
export * from './updateMensagensArquivos.mutation'
